import React from "react";

// import components
import EmprendedorSection from "./components/About2";
import VideoSection from './components/VideoSection2.js';
import MiddleSection from './components/MiddleSection.js';


const NewScreen = () => {
  return (
    <div className="max-w-[1920px] mx-auto overflow-hidden bg-white">
      <VideoSection />
      <MiddleSection />
      <EmprendedorSection />
    </div>
  );
};

export default NewScreen;
